import dynamic from 'next/dynamic'

export const SimpleHeaderSection = dynamic(
    () => import('./simple-header-section'),
)
